module.exports = __webpack_public_path__ + "fonts/6a265beb78a3a8dcf62031d2b4d0749b.svg";